var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasForecastFlow)?_c('block-item-card',{ref:"forecastFlowCard",attrs:{"show-background":false,"show-border":false}},[_c('forecast-flow-rugl-summary'),_c('forecast-flow-rugl-table',{attrs:{"items":_vm.items}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }